import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Brackets = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M16 3h3v18h-3" />
        <path d="M8 21H5V3h3" />
      </svg>
    );
  },
);

export default Brackets;
